import { TableConditionApi } from 'cadenza/api-client/conditions/table-condition-api';
import type { ConditionApiOptions } from 'cadenza/api-client/conditions/condition-api';

/** @see net/disy/services/conditions/AreaConditionEndpointController.java */
export class AreaConditionApi extends TableConditionApi {

  constructor (options: ConditionApiOptions) {
    super(options, '/areaConditionQuery');
  }

}
